import { Stack, Typography } from "@mui/material";
import NameField from "../NameField";
import type { CustomMeasureReturnType } from "../hooks/useCustomMeasure";
import GroupField from "./GroupField";
import SubgroupField from "./SubgroupField";
import type { MeasureDescriptor } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  measure: MeasureDescriptor | undefined;
  state: CustomMeasureReturnType;
  onError: (error?: string) => void;
}

export default function MainInfoComponent({ measure, state, onError }: Props) {
  return (
    <Stack spacing={2} useFlexGap>
      <Typography variant="subtitle1">Main Info</Typography>
      <NameField measure={measure} state={state} onError={onError} />
      <GroupField state={state} />
      <SubgroupField state={state} />
    </Stack>
  );
}
